import { CustomerModel } from "../../entities";
import { BaseODataRepository } from "../BaseODataRepository";

export class CustomerODataRepo extends BaseODataRepository<CustomerModel> {
  protected baseUrl = `/odata/customers`;
}

export default CustomerODataRepo;
